import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../context/AuthContext';
import queryParamsUtils from '../utils/queryParamsUtils';

export const PrivateRoute = ({ children }: any) => {
    const { loggedInUser } = useAuthStore();
    const { hasAuthorizedAppToken } = queryParamsUtils();

    const toComp = () => {
        return !!loggedInUser || hasAuthorizedAppToken();
    };

    if (!toComp) {
        return <Navigate to="/login" />;
    }

    return children;
};
